var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-footer',[_c('ion-toolbar',{staticClass:"footer"},[_c('MenuMain')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }